import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

const Icon = styled.img`
  height: 30px;
  transform: scaleX(-1);
`;

const IconContainer = styled.div`
  width: 30px;
  display: flex;
  justify-content: center;
`;

const TitleContainer = styled.div`
  width: calc(100% - 30px);
  padding-left: 10px;
`;

export default class NavbarIcon extends React.Component {
  render() {
    const { title, icon } = this.props;
    return (
      <Wrapper>
        <IconContainer>
          <Icon src={icon} />
        </IconContainer>
        <TitleContainer>
          {title}
        </TitleContainer>
      </Wrapper>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/NavBar/NavbarIcon.js